import { queryOptions, useQuery } from '@tanstack/react-query'
import { httpClient } from '@/shared/lib/httpClient'
import { apiV1 } from '@/shared/api/apiPrefix'
import { publicFeatureFlagsResponseSchema, type PublicFeatureFlagItem } from '@/shared/schemas/featureFlags.schema'

export const featureFlagKeys = {
  all: ['feature-flags'] as const,
  public: () => [...featureFlagKeys.all, 'public'] as const,
}

export const featureFlagsQueryOptions = queryOptions({
  queryKey: featureFlagKeys.public(),
  queryFn: async (): Promise<PublicFeatureFlagItem[]> => {
    const res = await httpClient.get<unknown>(apiV1('/feature-flags'))
    return publicFeatureFlagsResponseSchema.parse(res.data).data
  },
  staleTime: 5 * 60 * 1000,
})

export function usePublicFeatureFlags() {
  return useQuery(featureFlagsQueryOptions)
}

export type { PublicFeatureFlagItem }
